<script setup>
import DateTimeHelper from "@/common/DateTimeHelper";

const emit = defineEmits(["closed"]);
const { meeting } = defineProps({
  meeting: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

function formatStatus(status) {
  if (!status) return "Unknown";
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replace(/_/g, " ");
}

function onClose() {
  emit("closed");
}
</script>

<template>
  <div id="meeting">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <div><b>Scheduled Meeting</b></div>
        <div v-if="meeting.statusAtAgo" class="text-color-black-50">{{ meeting.statusAtAgo }}</div>
      </div>

      <span class="material-icons-round text-color-black-50 md-18 close-touchpoint" @click="onClose">
        close
      </span>
    </div>

    <div class="card-container mt-16">
      <div class="d-flex justify-content-between mb-8">
        <span class="field">Status</span>
        <span class="field-description" :class="'status-' + meeting.status">{{ formatStatus(meeting.status) }}</span>
      </div>
      <div v-if="meeting.starts_at" class="d-flex justify-content-between mb-8">
        <span class="field">Starts</span>
        <span class="field-description">{{ DateTimeHelper.exactDateTimeInTimezone(meeting.starts_at) }}</span>
      </div>
      <div v-if="meeting.ends_at" class="d-flex justify-content-between mb-8">
        <span class="field">Ends</span>
        <span class="field-description">{{ DateTimeHelper.exactDateTimeInTimezone(meeting.ends_at) }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.card-container {
  background-color: $black-5;
  padding: 12px;
  border-radius: $tf-global-border-radius;
}

.field {
  color: $black-50;
}

.field-description {
  font-weight: 500;
}

.status-active {
  color: $green-100;
}

.status-pending_reschedule {
  color: $tf-sourced-stopped-color;
}

.status-cancelled {
  color: $black-50;
}

.close-touchpoint {
  cursor: pointer;
}
</style>
